import React from 'react';
import { usePWA } from '../hooks/usePWA';
import { Download, Smartphone, Wifi, WifiOff, Bell } from 'lucide-react';
import { useLocalization } from '../contexts/LocalizationContext';

const PWAInstaller: React.FC = () => {
  const { t } = useLocalization();
  const {
    isInstallable, 
    isInstalled, 
    isOnline, 
    installApp, 
    requestNotificationPermission,
    sendNotification 
  } = usePWA();

  const handleInstall = async () => {
    await installApp();
    sendNotification(t('pwa.installed'), {
      body: t('pwa.installedDesc'),
      icon: '/LOGO_MOKO_A_fd_vert.png'
    });
  };

  const handleNotificationTest = async () => {
    const granted = await requestNotificationPermission();
    if (granted) {
      sendNotification(t('pwa.notifTest'), {
        body: t('pwa.notifEnabled'),
        icon: '/LOGO_MOKO_A_fd_vert.png'
      });
    }
  };

  if (isInstalled) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center">
          <Smartphone className="h-5 w-5 text-green-600 mr-3" />
          <div className="flex-1">
            <h4 className="font-semibold text-green-900">{t('pwa.alreadyInstalled')}</h4>
            <p className="text-sm text-green-700">{t('pwa.alreadyInstalledDesc')}</p>
          </div>
          <div className="flex items-center space-x-2">
            {isOnline ? (
              <Wifi className="h-4 w-4 text-green-600" />
            ) : (
              <WifiOff className="h-4 w-4 text-red-600" />
            )}
            <button
              onClick={handleNotificationTest}
              className="p-2 text-green-600 hover:bg-green-100 rounded-lg transition-colors duration-200"
            >
              <Bell className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!isInstallable) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Download className="h-5 w-5 text-blue-600 mr-3" />
          <div>
            <h4 className="font-semibold text-blue-900">{t('pwa.installApp')}</h4>
            <p className="text-sm text-blue-700">{t('pwa.installAppDesc')}</p>
          </div>
        </div>
        <button
          onClick={handleInstall}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium"
        >
          {t('pwa.install')}
        </button>
      </div>
    </div>
  );
};

export default PWAInstaller;